import { render, staticRenderFns } from "./InvestmentMechanismEnabledButton.vue?vue&type=template&id=2ae4b07b&scoped=true&"
import script from "./InvestmentMechanismEnabledButton.vue?vue&type=script&lang=js&"
export * from "./InvestmentMechanismEnabledButton.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentMechanismEnabledButton.vue?vue&type=style&index=0&id=2ae4b07b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae4b07b",
  null
  
)

export default component.exports